import type { RouteRecordRaw } from 'vue-router'
import { Actions, Subjects } from '@/rules/abilityTypes'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/client/:slug(.*)?',
    name: 'client',
    component: () => import('../views/ClientLIst.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.CLIENT,
      action: Actions.READ
    }
  },
  {
    path: '/client/:clientId/:slug(.*)?',
    name: 'clientEdit',
    component: () => import('../views/ClientEdit.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.CLIENT,
      action: Actions.WRITE
    }
  },
  {
    path: '/department/:slug(.*)?',
    name: 'department',
    component: () => import('../views/DepartmentList.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.DEPARTMENT,
      action: Actions.READ
    }
  },
  {
    path: '/department/:departmentId/:slug(.*)?',
    name: 'departmentEdit',
    component: () => import('../views/DepartmentEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.DEPARTMENT,
      action: Actions.WRITE
    }
  },
  {
    path: '/job_skill/:slug(.*)?',
    name: 'jobSkill',
    component: () => import('../views/JobSkillList.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.JOB_SKILL,
      action: Actions.READ
    }
  },
  {
    path: '/job_skill/:jobSkillId/:slug(.*)?',
    name: 'jobSkillEdit',
    component: () => import('../views/JobSkillEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.JOB_SKILL,
      action: Actions.WRITE
    }
  },
  {
    path: '/job_title/:slug(.*)?',
    name: 'jobTitle',
    component: () => import('../views/JobTitleList.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.JOB_TITLE,
      action: Actions.READ
    }
  },
  {
    path: '/job_title/:jobTitleId/:slug(.*)?',
    name: 'jobTitleEdit',
    component: () => import('../views/JobTitleEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.JOB_TITLE,
      action: Actions.WRITE
    }
  },
  {
    path: '/partner/:slug(.*)?',
    name: 'partner',
    component: () => import('../views/PartnerList.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.PARTNER,
      action: Actions.READ
    }
  },
  {
    path: '/partner/:partnerId/:slug(.*)?',
    name: 'partnerEdit',
    component: () => import('../views/PartnerEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      subject: Subjects.PARTNER,
      action: Actions.WRITE
    }
  },
  {
    path: '/holiday/:slug(.*)?',
    name: 'holiday',
    component: () => import('../views/HolidayList.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.HOLIDAY,
      action: Actions.WRITE
    }
  },
  {
    path: '/custom_field/:slug(.*)?',
    name: 'customField',
    component: () => import('../views/CustomFieldList.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.CUSTOM_FIELD,
      action: Actions.READ
    }
  },
  {
    path: '/custom_field/:customFieldId/:slug(.*)?',
    name: 'customFieldEdit',
    component: () => import('../views/CustomFieldEdit.vue'),
    props: true,
    meta: {
      stackable: true,
      requiresAuth: true,
      requiresDB: true,
      subject: Subjects.CUSTOM_FIELD,
      action: Actions.WRITE
    }
  },
  {
    path: '/setting/:slug(.*)?',
    name: 'setting',
    component: () => import('../views/SettingEdit.vue'),
    meta: {
      requiresAuth: true,
      requiresDB: true,
      stackable: true,
      subject: Subjects.SETTING,
      action: Actions.WRITE
    }
  }
]

export default routes
